import { serviceRoles } from "config/access";
import { STUDENTS } from "constants/routes";
import { checkAccess } from "helpers/auth";
import StudentsPage from "./container/StudentsPage";

export default function getSettingsRoute(userAuth) {
  const { account, harmony } = serviceRoles;
  const requireAuth = {
    [account.name]: [account.roles.superadmin],
    [harmony.name]: [harmony.roles.admin],
    [harmony.gateway]: [harmony.roles.gateway],
  };
  return {
    requireAuth,
    onEnter: () => checkAccess(requireAuth, userAuth),
    path: STUDENTS,
    withSidebar: true,
    withAppBar: true,
    component: StudentsPage,
  };
}
